import Toastify from "toastify-js";

export function toggleSpinner(element, show) {
    const spinner = element.querySelector('.fa-spinner');

    element.disabled = show;

    if (spinner) {
        spinner.style.display = show ? 'inline-block' : 'none';
    }
}

export function showToast(message, type = 'success') {
    Toastify({
        text: message,
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "bottom",
        position: "right",
        stopOnFocus: true,
        style: {
            background: type === 'success' ? "green" : "red",
        }
    }).showToast();
}

export async function updateCart(selectedProducts, addToCartBtn) {
    jQuery.post(ajax_object.ajax_url, {
        action: 'update_cart',
        selectedProducts: selectedProducts
    }, 'json')
        .done(function (data) {
            data = JSON.parse(data);

            if (data === '') {
                showToast("Erreur lors de la mise à jour du panier.", 'error');
            } else if (data.success === false) {
                showToast(data.message, 'error');

                if (data.reload === true) {
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                }
            } else {
                showToast("Panier mis à jour avec succès.");
            }
        })
        .fail(function () {
            showToast("Erreur lors de la mise à jour du panier.", 'error');
        })
        .always(function (data, textStatus, jqXHR) {
            data = JSON.parse(data);
            console.log(data, textStatus, jqXHR);
            toggleSpinner(addToCartBtn, false);
        });
}

export async function updateCartWithBundle(selectedProduct, btn, callback, goal) {
    jQuery.post(ajax_object.ajax_url, {
        action: 'update_cart_with_bundle',
        selectedProduct: selectedProduct,
        goal: goal
    }, 'json')
        .done(function (data) {
            data = JSON.parse(data);

            if (data === '') {
                showToast("Erreur lors de la mise à jour du panier.", 'error');
            } else if (data.success === false) {
                showToast(data.message, 'error');

                if (data.reload === true) {
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                }
            } else {
                showToast("Panier mis à jour avec succès.");

                callback();
            }
        })
        .fail(function () {
            showToast("Erreur lors de la mise à jour du panier.", 'error');
        })
        .always(function (data, textStatus, jqXHR) {
            data = JSON.parse(data);
            console.log(data, textStatus, jqXHR);
            toggleSpinner(btn, false);
        });
}

export function addBundleToCart(secondStepChoiceProductId, secondStepChoiceOfferId, btn, callback, goal) {
    toggleSpinner(btn, true);

    const selectedProduct = {
        productId: secondStepChoiceProductId,
        offerId: secondStepChoiceOfferId,
        implementation: {
            startDate: new Date().toISOString().split('T')[0]
        }
    }

    updateCartWithBundle(selectedProduct, btn, callback, goal);
}
export function reload() {
    window.location.href = window.location.href + (window.location.href.indexOf('?') !== -1 ? '&' : '?') + 'nocache=' + new Date().getTime();
}

const contentReady = new CustomEvent('contentReady');

export function handleReloadedContent(targetContent, dispatchEvent = true) {
    const reloadContainer = targetContent.querySelector('.reload-container');

    if (reloadContainer) {
        reload();
    } else if(dispatchEvent) {
        window.dispatchEvent(contentReady);
    }
}